<template>
  <div class="content">
    <div class="content-inner-fix" id="content">
      <!-- 경로 표시 -->
      <div class="location">
        <ol>
          <li>
            <a href="#" title="홈">
              <i class="ico ico-home"><span class="ir-text">홈</span></i>
            </a>
          </li>
          <li class="font-body-style4">
            통합검색
          </li>
        </ol>
      </div>

      <!-- 페이지 타이틀 및 검색 영역 -->
      <div class="page-title-wrap new-sch">
        <div class="page-title">
          <div class="h1-title">통합검색</div>
        </div>
        <div class="search-wrap">
          <div class="input-group search">
            <div class="input-group-inner">
              <input
                  type="text"
                  class="font-body-style3"
                  placeholder="검색어를 입력해주세요."
                  title="검색어 입력"
                  v-model="searchQuery"
                  @keyup.enter="handleSearch"
              >
              <button
                  type="button"
                  class="btn-search"
                  aria-label="검색 버튼"
                  @click="handleSearch" title="검색 버튼">
                <i class="ico ico-search"><span class="ir-text">검색</span></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 컨텐츠 섹션 -->
      <div class="content-section new-pd-type">
        <div class="job-posting-container global-search new-ver">

          <!-- 탭 컨테이너 - SearchContent 컴포넌트 -->
          <SearchContent
              ref="searchTabs"
              :search-query="searchQuery"
              :search-results="searchResults"
              :is-loading="isLoading"
              :has-searched="hasSearched"
              :center-orgs-data="centerOrgsData"
              @search="executeSearch"
              @tab-change="handleTabChange"
              @tag-search="handleTagSearch"
          />

          <!-- 검색 키워드 섹션 -->
          <div class="search-keyword">
            <!-- 인기 검색어 컴포넌트 -->
            <PopularSearches
                ref="popularSearches"
                :key="`${currentActiveOrg}-${currentActiveCenter}`"
                :org-type="currentActiveOrg"
                :center-type="currentActiveCenter"
                :show-search-count="false"
                :show-refresh-button="false"
                :auto-refresh-interval="300000"
                @search-keyword="handlePopularSearchClick"
            />
            <div class="search-box recent-search">
              <h2 class="search-box-title">내 검색어</h2>
              <ul class="search-list">
                <li v-for="(keyword, index) in recentSearches" :key="index">
                  <a href="#" @click.prevent="searchKeyword(keyword)" aria-label="내 검색어 페이지로 이동" title="내 검색어 페이지로 이동">
                    {{ keyword }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchContent from './SearchContent.vue';
import PopularSearches from './PopularSearches.vue';
import {SearchApiService} from './services/searchApiService';

export default {
  name: 'UnifiedSearchPage',
  components: {
    SearchContent,
    PopularSearches
  },
  props: {
    centerOrgsData: {
      type: Array,
      default: () => []
    },
    initialParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 검색 관련
      searchQuery: '',
      searchResults: {},
      isLoading: false,
      hasSearched: false,

      // 탭 상태
      currentSubTab: 'ALL',
      currentActiveOrg: 'job-info', // 현재 활성 탭
      currentActiveCenter: '', // 현재 활성 센터

      // 최근 검색어
      recentSearches: []
    };
  },
  async mounted() {
    // URL 파라미터에서 검색어 확인
    await this.initializeFromUrl();
  },
  methods: {
    async initializeFromUrl() {
      // props로 받은 initialParams 우선 사용
      let queryParam;
      let searchPage;
      let orgCd;

      if (this.initialParams && Object.keys(this.initialParams).length > 0) {
        // JSP에서 전달받은 초기 파라미터 사용
        queryParam = this.initialParams.query;
        searchPage = this.initialParams.searchPage;
        orgCd = this.initialParams.orgCd;
      } else {
        // fallback: URL에서 직접 파라미터 추출
        const urlParams = new URLSearchParams(window.location.search);
        queryParam = urlParams.get('query');
        searchPage = urlParams.get('searchPage');
        orgCd = urlParams.get('orgCd');
      }

      if (queryParam) {
        this.searchQuery = decodeURIComponent(queryParam);

        // 기관 및 센터 정보 추출
        let orgType;
        let centerType;

        // initialParams에 orgType이 이미 변환되어 있으면 사용
        if (this.initialParams && this.initialParams.initialOrgType) {
          orgType = this.initialParams.initialOrgType;
        } else {
          // fallback: searchPage에서 orgType 결정
          switch (searchPage) {
            case 'job':
              orgType = 'job-info';
              break;
            case 'foundation':
              orgType = 'foundation';
              break;
            case 'portal':
            case 'senior-info':
              orgType = 'senior-info';
              break;
            case 'center':
              orgType = 'center';
              break;
            default:
              orgType = 'job-info';
          }
        }

        // 센터 타입 결정
        if (orgType === 'center' && orgCd) {
          centerType = orgCd;
        }

        // 초기 활성 탭 설정
        this.currentActiveOrg = orgType;
        this.currentActiveCenter = centerType || '';

        // URL 파라미터 기반으로 검색 실행
        await this.executeSearch({
          orgType,
          menuType: 'ALL',
          centerType
        });
      }
    },

    handleSearch() {
      // SearchContent 컴포넌트에서 현재 검색 상태를 가져와서 유지
      let currentParams = {};

      if (this.$refs.searchTabs) {
        currentParams = {
          orgType: this.$refs.searchTabs.activeOrg || 'job-info',
          menuType: this.$refs.searchTabs.activeMenu || 'ALL',
          centerType: this.$refs.searchTabs.activeCenter || '',
          filters: {
            ...this.$refs.searchTabs.searchFilters
          }
        };
      }

      this.executeSearch(currentParams);

      if (this.searchQuery.trim()) {
        this.updateRecentSearches(this.searchQuery.trim());
      }
    },

    async executeSearch(searchParams = {}) {
      this.isLoading = true;
      this.hasSearched = true;

      try {
        // 기본 검색 파라미터 설정
        const params = {
          query: this.searchQuery.trim(),
          realQuery: '',
          orgType: 'job-info',
          menuType: 'ALL',
          ...searchParams
        };

        // 현재 탭이 전체가 아닌 개별 메뉴 탭인 경우 검색 결과를 10건으로 고정
        if (params.menuType !== 'ALL') {
          if (!params.filters) {
            params.filters = {};
          }
          params.filters.searchSel = '10';
          params.filters.startCount = 0;
        }

        // 검색 API 호출
        this.searchResults = await SearchApiService.search(params);

        this.updateUrl(params);

      } catch (error) {
        this.searchResults = {};
      } finally {
        this.isLoading = false;
      }
    },

    handleTabChange(tabInfo) {
      // SearchContent에서 탭 변경 시 호출
      const {searchParams} = tabInfo;

      // 탭 상태 업데이트
      this.currentSubTab = searchParams.menuType;
      this.currentActiveOrg = searchParams.orgType;
      this.currentActiveCenter = searchParams.centerType || '';

      this.executeSearch(searchParams);

    },

    searchKeyword(keyword) {
      this.searchQuery = keyword;

      // Vue 반응성 업데이트 후 검색 실행 (검색어가 자식 컴포넌트에 전달되도록)
      this.$nextTick(() => {
        // SearchContent 컴포넌트의 탭을 전체로 리셋 (검색은 resetToAllTab에서 실행됨)
        if (this.$refs.searchTabs && this.$refs.searchTabs.resetToAllTab) {
          this.$refs.searchTabs.resetToAllTab();
          return; // resetToAllTab이 검색을 실행하므로 여기서 종료
        }

        // resetToAllTab이 없는 경우에만 직접 검색 실행
        this.executeSearch({
          orgType: 'job-info',
          menuType: 'ALL',
          centerType: ''
        });
      });
    },

    // 인기 검색어 클릭 처리 (PopularSearches 컴포넌트에서 호출)
    handlePopularSearchClick(keyword) {
      this.searchQuery = keyword;

      // Vue 반응성 업데이트 후 검색 실행 (검색어가 자식 컴포넌트에 전달되도록)
      this.$nextTick(() => {
        // SearchContent 컴포넌트의 탭을 전체로 리셋 (검색은 resetToAllTab에서 실행됨)
        if (this.$refs.searchTabs && this.$refs.searchTabs.resetToAllTab) {
          this.$refs.searchTabs.resetToAllTab();
          this.updateRecentSearches(keyword);
          return; // resetToAllTab이 검색을 실행하므로 여기서 종료
        }

        // resetToAllTab이 없는 경우에만 직접 검색 실행
        this.executeSearch({
          orgType: 'job-info',
          menuType: 'ALL',
          centerType: ''
        });

        // 최근 검색어에 추가
        this.updateRecentSearches(keyword);
      });
    },

    // 태그 클릭 처리 (SearchContent 컴포넌트에서 호출)
    handleTagSearch(tag) {
      this.searchQuery = tag;

      // 태그 클릭 시 현재 탭 상태를 유지하면서 검색
      const currentParams = {};

      if (this.$refs.searchTabs) {
        currentParams.orgType = this.$refs.searchTabs.activeOrg;
        currentParams.menuType = this.$refs.searchTabs.activeMenu;
        currentParams.centerType = this.$refs.searchTabs.activeCenter;
        currentParams.filters = {
          ...this.$refs.searchTabs.searchFilters
        };
      }

      // 현재 탭 상태 유지하면서 태그 검색 실행
      this.executeSearch(currentParams);

      // 최근 검색어에 추가
      if (tag.trim()) {
        this.updateRecentSearches(tag.trim());
      }
    },

    updateRecentSearches(query) {
      // 중복 제거 후 최신 검색어를 맨 앞에 추가
      this.recentSearches = [query, ...this.recentSearches.filter(item => item !== query)].slice(0, 5);
      localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    },

    loadRecentSearches() {
      const saved = localStorage.getItem('recentSearches');
      if (saved) this.recentSearches = JSON.parse(saved);
    },


    updateUrl(searchParams = {}) {
      const params = new URLSearchParams();
      const {orgType = 'job-info', centerType} = searchParams;

      if (this.searchQuery.trim()) params.set('query', this.searchQuery.trim());

      const searchPageMap = {
        'job-info': 'job',        // 일자리정보몽땅
        'foundation': 'foundation',      // 재단
        'senior-info': 'senior-info',     // 라이프몽땅
        'center': 'center'           // 센터
      };
      params.set('searchPage', searchPageMap[orgType] || 'job');

      // 센터인 경우 조직 코드 추가
      if (orgType === 'center') {
        // centerType이 있으면 사용, 없으면 initialParams의 orgCd 사용
        const orgCode = centerType || (this.initialParams && this.initialParams.orgCd);
        if (orgCode) params.set('orgCd', orgCode);
      }

      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }
  },

  created() {
    // 컴포넌트 생성 시 최근 검색어 로드
    this.loadRecentSearches();
  }
};
</script>



// WEBPACK FOOTER //
// UnifiedSearchPage.vue?c976bce0